exports.getPhone = ({ area, areas }) => {
    if (!area) return { success: false };
    let a = areas.find((item) => item.name === area);
    if (a && a.phone)
        return {
            success: true,
            phone: a.phone,
            wsp: a.isWspAvailable,
        };
    return { success: false };
};

exports.getFb = ({ area, areas }) => {
    let a = areas.find((item) => item.name === area);
    if (a && a.fb) return { success: true, fb: a.fb };
    return { success: false };
};

exports.getAreaByPhone = ({ phone, areas }) => {
    let a = areas.find((item) => item.phone === phone);
    if (a && a.name) return { success: true, name: a.name };
    return { success: false };
};

exports.getAreaByFb = ({ fb, areas }) => {
    let a = areas.find((item) => item.fb === fb);
    if (a && a.name) return { success: true, name: a.name };
    return { success: false };
};

exports.getConversationFromNumber = ({ channel, area, areas }) => {
    if (channel === 'whatsapp') {
        let response = this.getPhone({ area, areas });
        if (!response.success) return false;

        return response.phone;
    }

    if (channel === 'messenger') {
        let response = this.getFb({ area, areas });
        if (!response.success) return false;

        return response.fb;
    }
};

/**
 * Returns a object that have specific store area data
 *
 * @param {Object} param
 * @param {string } param.area- The store area !important(don't use user area)
 * @param {array} param.areas- store areas
 *
 * @return {any} returns store area data or { success: false } object
 */
exports.getAreaByWsp = ({ area, areas }) => {
    if (!area) return { success: false };
    let a = areas.find((item) => item.name === area);
    if (a && (a.phone || a.whatsapp))
        return {
            area: a.name,
            success: true,
            phone: a.phone,
            wsp: a.isWspAvailable,
            api: a.api,
            whatsapp: a.whatsapp,
        };
    return { success: false };
};

exports.getPhoneOrWsp = ({ area, areas }) => {
    if (!area) return { success: false };
    let a = areas.find((item) => item.name === area);
    if (a && (a.phone || a.whatsapp))
        return {
            success: true,
            phone: a.phone,
            wsp: a.isWspAvailable,
            whatsapp: a.whatsapp,
        };
    return { success: false };
};

exports.getAreaData = ({ area, areas }) => {
    if (!area) return { success: false };
    let areaData = areas.find((item) => item.name === area);
    if (areaData?._id) return areaData;

    return { success: false };
};
